<script>
export default {
    name: 'IconClassBookLight',
}
</script>
<template>
    <svg class="base-icon icon-class-book-light" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64"><path fill="currentColor"  d="M0 6.2a3.233 3.233 0 0 1 .936-2.255A3.189 3.189 0 0 1 3.174 3h57.652C62.579 3 64 4.434 64 6.2v51.6a3.234 3.234 0 0 1-.936 2.255 3.189 3.189 0 0 1-2.238.945H3.174c-.842 0-1.65-.338-2.244-.938A3.211 3.211 0 0 1 0 57.8V6.2Zm28.8 3.244H6.4v45.112h22.4V9.444Zm6.4 0v45.112h22.4V9.444H35.2Zm3.2 6.445h16v6.444h-16V15.89Zm0 9.667h16V32h-16v-6.444Z"/></svg>
</template>
